import { render } from "./AddFormModal.vue?vue&type=template&id=210b5f4e&ts=true"
import script from "./AddFormModal.vue?vue&type=script&lang=ts"
export * from "./AddFormModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__